// reservationFormRows.js — 예약 신규 등록 폼의 줄(항공·호텔·렌트·결제) 도우미.
//   ReservationForm.jsx(333줄)에서 그대로 옮김(2026-10-27, 300줄 규칙, 동작 변화 없음).
import { todayKST } from '../../utils/date';
import { defaultNightlyRates } from './reservationmgmt/HotelNightlyRatesEditor';

export const blank = (init = {}) => ({ ...init });
export const blankHotel = () => blank({ nightly_rates: defaultNightlyRates() });
export const MASTER_OPTIONAL_KEYS = ['customer_phone', 'travel_start', 'travel_end', 'adult_count', 'child_count', 'infant_count'];
export const MASTER_EXTRA_KEYS = ['status', 'customer_email', 'source'];

export function flightTotal(row = {}) {
  return Number(row.base_fare || 0) + Number(row.fuel_surcharge || 0) + Number(row.taxes || 0);
}

export function cleanRows(rows = []) {
  return rows.map(({ notes, ...row }) => row);
}

export function hasUserInput(row = {}) {
  return Object.entries(row).some(([key, value]) => (
    key !== 'total_payment' && value !== null && value !== undefined && value !== ''
  ));
}

export function cleanFlights(rows = []) {
  return rows
    .filter(hasUserInput)
    .map(({ notes, ...row }) => ({ ...row, total_payment: flightTotal(row) }));
}

export function normalizePaymentRow(row = {}) {
  if (row.payment_method === 'card') return { ...row, cash_receipt_issue_no: null, cash_receipt_amount: null };
  if (row.payment_method === 'cash') return { ...row, card_deposit_memo: null };
  return row;
}

const PAYMENT_INPUT_KEYS = ['amount', 'payment_method', 'cash_receipt_issue_no', 'cash_receipt_amount', 'card_deposit_memo'];

function hasPaymentInput(row = {}) {
  return PAYMENT_INPUT_KEYS.some((key) => hasUserInput({ [key]: row[key] }));
}

export function cleanPayments(rows = []) {
  return rows.map(normalizePaymentRow).filter(hasPaymentInput);
}

export const blankPayment = () => blank({ payment_date: todayKST() });
